import { Link } from '@tanstack/react-router'
import { LayoutDashboard } from 'lucide-react'
import { useAuthStore } from '../lib/auth'
import { BrandLogo } from './BrandLogo'

export function MarketplaceLayout({ children, returnTo, className = '' }: { children: React.ReactNode; returnTo?: string; className?: string }) {
  const { isAuthenticated } = useAuthStore()

  return (
    <div className={`min-h-screen flex flex-col bg-background ${className}`}>
      <header className="sticky top-0 z-40 border-b border-border bg-white">
        <div className="mx-auto flex min-h-20 max-w-7xl flex-wrap items-center justify-between gap-3 px-4 py-3 sm:px-6 lg:px-8">
          <Link to="/" aria-label="Roomsi home" className="rounded-md">
            <BrandLogo />
          </Link>
          <nav aria-label="Main navigation" className="flex flex-wrap items-center gap-3 sm:gap-6">
            {isAuthenticated ? (
              <Link to="/dashboard" className="inline-flex min-h-11 items-center gap-2 rounded-md border border-border px-4 py-2 text-sm font-semibold hover:bg-muted">
                <LayoutDashboard className="h-4 w-4" />
                Dashboard
              </Link>
            ) : (
              <>
                <Link to="/login" search={{ returnTo }} className="inline-flex min-h-11 items-center text-sm font-semibold hover:underline underline-offset-4">
                  Sign in
                </Link>
                <Link to="/register" className="hidden min-h-11 items-center rounded-md border border-border px-4 py-2 text-sm font-semibold hover:bg-muted sm:inline-flex">
                  List your rooms
                </Link>
              </>
            )}
          </nav>
        </div>
      </header>
      {children}
      <footer className="mt-auto border-t border-border bg-muted/50">
        <div className="mx-auto flex max-w-7xl flex-col gap-5 px-4 py-8 sm:flex-row sm:items-center sm:justify-between sm:px-6 lg:px-8">
          <Link to="/" aria-label="Roomsi home"><BrandLogo size="sm" /></Link>
          <p className="text-sm text-muted-foreground">Helping communities share their spaces.</p>
          <nav aria-label="Footer navigation" className="flex flex-wrap gap-5 text-sm font-medium">
            <Link to="/marketplace" className="hover:underline underline-offset-4">Find a room</Link>
            <Link to="/register" className="hover:underline underline-offset-4">List your rooms</Link>
            <a href="/help/" className="hover:underline underline-offset-4">Admin guide</a>
          </nav>
        </div>
        <div className="mx-auto flex max-w-7xl flex-wrap justify-between gap-3 px-4 pb-6 text-xs text-muted-foreground sm:px-6 lg:px-8">
          <p>Copyright {new Date().getFullYear()} Roomsi</p>
          <p>In partnership with <a href="https://circularity.org" target="_blank" rel="noopener noreferrer" className="text-gray-900 underline underline-offset-4">circularity.org</a></p>
        </div>
      </footer>
    </div>
  )
}